import { createSelector } from "reselect";
import { feedEntitiesByTypeSelector } from "orion-components/GlobalData/Selectors";

export const selectCameraEntity = (cameraIds, isOnAlertProfile) =>
	createSelector(
		state => state,
		state => {
			const cameraEntities = [];
			if (isOnAlertProfile) {
				cameraIds.forEach(cameraId => {
					if (!state?.contextualData?.[cameraId]?.entity) return;
					cameraEntities.push(state.contextualData[cameraId].entity);
				});
			} else {
				const feedEntities = feedEntitiesByTypeSelector("camera")(state);
				cameraIds.forEach(cameraId => {
					if (!feedEntities?.[cameraId]) return;
					cameraEntities.push(feedEntities[cameraId]);
				});
			}

			if (cameraIds.length > 0 && cameraEntities.length === 0) {
				return "Not available";
			}

			return cameraEntities;
		}
	);
